import { render, staticRenderFns } from "./ExercisesSubtitles.vue?vue&type=template&id=0ae655a5"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ExercisesSubtitles.vue?vue&type=style&index=0&id=0ae655a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports